import { useContext } from 'react';

import { GoalProgressContext } from './goal-progress-context';

export const useOpenGoalProgressHistory = () => {
  const { onOpenGoalProgressHistory } = useContext(GoalProgressContext);

  return onOpenGoalProgressHistory;
};
